import { profile } from '../data/resume';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <p>© {new Date().getFullYear()} {profile.name}</p>
        <p className="footer-note">Designed & built with React</p>
      </div>
    </footer>
  );
}
